import { isMagnetInPublishedState } from "utils/helpers";
import { useDataProviderContext } from "../../DataProvider";
import ReleaseComponent from "./ReleaseComponent";

function ReleaseContainer() {
  const { magnetId, loading, magnetDetailsState: data, reloadMagnetDetails, isRefetching } = useDataProviderContext();
  const { releases, max_supply: maxSupply, available_supply: magnetAvailableSupply, status } = data || {};

  if (loading) {
    return null;
  }

  return (
    <ReleaseComponent
      isMagnetPublished={isMagnetInPublishedState(status as MagnetStates)}
      magnetIdFromUrl={magnetId}
      magnetMaxSupply={maxSupply as number}
      magnetAvailableSupply={magnetAvailableSupply as number}
      releases={releases || []}
      reloadMagnetDetails={reloadMagnetDetails}
      isRefetching={isRefetching}
    />
  );
}

export default ReleaseContainer;
